import {Action} from "../../../action/action";
import type DetailsState from "..";
import {GiftCard, GoDreamGiftCard, Validators} from "@raskrask-dk/raskrask-utils";
export const SET_GIFT_CARD = "SET_GIFT_CARD";

export class SetGiftCard extends Action<typeof SET_GIFT_CARD, GiftCard> {
  readonly type = SET_GIFT_CARD;
  protected state: DetailsState;

  constructor(state: DetailsState, giftCardCode?: GiftCard | undefined) {
    super(state, giftCardCode);
    this.state = state;
  }
  /**
   * Business Logic:
   * This action is only doable if there's been chosen a giftcardprovider
   * @returns
   */
  public isDoable(): boolean {
    return true;
  }
  public isValid(): boolean {
    const codeToCheck = this.getFullGiftCode();
    const isGiftCardCodeValid = Validators.giftCardCodeValidator(codeToCheck, this.data.giftCardProvider);
    return this.isDoable() && isGiftCardCodeValid;
  }
  private getFullGiftCode(): string {
    if (this.data instanceof GoDreamGiftCard) {
      return `${this.data.code} ${this.data.activationCode}`;
    } else return this.data.code;
  }
}
